import React from 'react';
import { useDispatch } from 'react-redux';
import { setCategoryTabOpen } from "../Actions/FacetedSearch.action";
import { Svg } from './Svg';

const SubnavCloseButton = () => {
    const dispatch = useDispatch();
    return (
        <button onClick={() => dispatch(setCategoryTabOpen(false))} className='subnav__close-button'>
            <Svg icon="close" />
        </button>
    );
};

export default SubnavCloseButton;